// src/components/compartidos/FloatingHelp.js
import React, { useState, useRef, useEffect } from 'react';
import './FloatingHelp.css';

// ============================================
// ICONO: Robot pensando
// ============================================
const RobotThinkingIcon = () => (
  <svg
    className="robot-thinking-icon"
    width="44"
    height="44"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Antena */}
    <line x1="32" y1="4" x2="32" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="32" cy="3.5" r="2.5" fill="currentColor">
      <animate attributeName="opacity" values="1;0.4;1" dur="1.8s" repeatCount="indefinite" />
    </circle>

    {/* Cabeza del robot */}
    <rect x="14" y="12" width="36" height="30" rx="8" fill="currentColor" opacity="0.15" />
    <rect x="14" y="12" width="36" height="30" rx="8" stroke="currentColor" strokeWidth="2.5" />

    {/* Pantalla/cara */}
    <rect x="19" y="18" width="26" height="18" rx="4" fill="white" opacity="0.25" />

    {/* Ojos (puntos que parpadean / piensan) */}
    <circle cx="26" cy="27" r="2.8" fill="currentColor">
      <animate attributeName="r" values="2.8;0.5;2.8" dur="2.2s" repeatCount="indefinite" />
    </circle>
    <circle cx="38" cy="27" r="2.8" fill="currentColor">
      <animate attributeName="r" values="2.8;0.5;2.8" dur="2.2s" repeatCount="indefinite" />
    </circle>

    {/* Boca tipo sonrisa/circuito */}
    <path d="M27 33 Q32 35 37 33" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />

    {/* Orejas/lados laterales */}
    <rect x="9" y="22" width="5" height="10" rx="2" stroke="currentColor" strokeWidth="2.5" fill="none" />
    <rect x="50" y="22" width="5" height="10" rx="2" stroke="currentColor" strokeWidth="2.5" fill="none" />

    {/* Burbuja de pensamiento (puntos ascendentes a la derecha) */}
    <circle cx="52" cy="9" r="1.8" fill="currentColor" opacity="0.5">
      <animate attributeName="opacity" values="0.2;0.7;0.2" dur="2s" repeatCount="indefinite" />
    </circle>
    <circle cx="57" cy="5" r="2.6" fill="currentColor" opacity="0.6">
      <animate attributeName="opacity" values="0.3;0.8;0.3" dur="2s" begin="0.4s" repeatCount="indefinite" />
    </circle>
  </svg>
);

// ============================================
// ICONOS SVG PARA LAS CATEGORÍAS
// ============================================
const GeneralIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><line x1="12" y1="16" x2="12" y2="12" /><line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);
// Componente `ProductIcon` que renderiza esta parte de la interfaz.
const ProductIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="9" y1="13" x2="15" y2="13" /><line x1="9" y1="17" x2="13" y2="17" />
  </svg>
);
// Componente `BillingIcon` que renderiza esta parte de la interfaz.
const BillingIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
// Componente `DeliveryIcon` que renderiza esta parte de la interfaz.
const DeliveryIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" /><polyline points="3.27 6.96 12 12.01 20.73 6.96" /><line x1="12" y1="22.08" x2="12" y2="12" />
  </svg>
);
// Componente `SecurityIcon` que renderiza esta parte de la interfaz.
const SecurityIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><polyline points="9 11 11 13 15 9" />
  </svg>
);
// Componente `AccountIcon` que renderiza esta parte de la interfaz.
const AccountIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
  </svg>
);

// ============================================
// DATA: FAQs agrupadas por categoría
// ============================================
const FAQ_CATEGORIES = [
  {
    id: 'general',
    label: 'General',
    icon: <GeneralIcon />,
    faqs: [
      {
        question: '¿Qué es Wisby Legal?',
        answer: 'Somos una plataforma LegalTech que permite a empresas y emprendedores generar, firmar y gestionar documentos corporativos (como Títulos Accionarios y Poderes Legales) de manera 100% digital, automatizada y con plena validez jurídica en México.',
      },
      {
        question: '¿Tienen validez legal las firmas digitales?',
        answer: 'Sí, absolutamente. Utilizamos DocuSign para certificar todas las firmas electrónicas. Esto cumple con la NOM-151 y el Código de Comercio en México, otorgando a tus documentos la misma validez legal que una firma autógrafa tradicional.',
      },
      {
        question: '¿Qué diferencia hay entre la entrega Digital y Física?',
        answer: 'La entrega Digital te proporciona un PDF certificado con firmas electrónicas de forma inmediata. La entrega Física incluye la impresión de tu documento en papel seguridad con hologramas, la firma autógrafa de nuestro representante legal y el envío hasta tu domicilio vía DHL Express.',
      },
      {
        question: '¿En qué país operan?',
        answer: 'Nuestra plataforma y todos nuestros documentos están diseñados para cumplir con la legislación mexicana. Operamos en toda la República Mexicana y los documentos tienen plena validez jurídica dentro del territorio nacional.',
      },
    ],
  },
  {
    id: 'productos',
    label: 'Productos',
    icon: <ProductIcon />,
    faqs: [
      {
        question: '¿Qué es un Título Accionario (Boleta)?',
        answer: 'Es el documento legal que acredita la titularidad de acciones dentro de una sociedad. A través de Wisby puedes generar boletas accionarias con datos de constitución, capital social y series de acciones, listas para firmar digitalmente.',
      },
      {
        question: '¿Qué datos necesito para crear una Acción?',
        answer: 'Necesitarás los datos de constitución de la empresa (Número de Escritura, Notario, Folio Mercantil), los datos personales del accionista, el capital social y la cantidad de acciones por serie a emitir. Puedes guardar tu progreso si te falta algún dato.',
      },
      {
        question: '¿Qué tipos de Poderes Legales puedo otorgar?',
        answer: 'Ofrecemos tres tipos: Poder General (Pleitos y Cobranzas), Poder Bancario y Financiero, y Poder Administrativo. Cada uno se adapta a distintas facultades que deseas conferir a tu apoderado.',
      },
      {
        question: '¿Qué es una Asamblea y por qué la necesito para un Poder?',
        answer: 'El otorgamiento de un poder requiere un acto de asamblea (Ordinaria o Extraordinaria) donde los accionistas acuerdan las facultades a delegar. Nuestra plataforma guía el proceso paso a paso para generar la documentación correcta.',
      },
      {
        question: '¿Puedo guardar mi progreso y continuar después?',
        answer: 'Sí. Si te falta algún dato o prefieres revisar la información antes de continuar, puedes guardar tu progreso y retomar el trámite cuando lo desees desde tu perfil.',
      },
    ],
  },
  {
    id: 'facturacion',
    label: 'Facturación',
    icon: <BillingIcon />,
    faqs: [
      {
        question: '¿Cómo solicito la factura (CFDI) de mi trámite?',
        answer: 'Es muy sencillo. Una vez realizado el pago, entra a la sección "Facturación" desde el menú de tu perfil (arriba a la derecha). Ahí podrás ingresar tus datos fiscales y el sistema te enviará la factura 4.0 al instante.',
      },
      {
        question: '¿Qué métodos de pago aceptan?',
        answer: 'Procesamos los pagos de forma segura a través de Stripe. Aceptamos tarjetas Visa, Mastercard y American Express, además de Apple Pay y Google Pay.',
      },
      {
        question: '¿Los precios incluyen IVA?',
        answer: 'Sí. Todos nuestros precios se expresan en pesos mexicanos (MXN) e incluyen los impuestos aplicables (IVA). El precio que ves al finalizar es el total que pagarás.',
      },
      {
        question: '¿Cuánto cuesta cada trámite?',
        answer: 'La entrega Digital tiene un precio base y la entrega Física incluye costos adicionales por impresión en papel seguridad y envío por DHL Express. Los precios exactos se muestran en el momento de seleccionar tu plan, antes de pagar.',
      },
      {
        question: '¿Puedo obtener un reembolso?',
        answer: 'Los reembolsos se evalúan caso por caso. Si el trámite aún no ha iniciado su procesamiento, contáctanos a soporte@wisby.legal para revisar tu solicitud. Una vez que el documento ha sido generado o enviado, no es posible reembolsar.',
      },
    ],
  },
  {
    id: 'envios',
    label: 'Entregas',
    icon: <DeliveryIcon />,
    faqs: [
      {
        question: '¿En cuánto tiempo recibo mi documento digital?',
        answer: 'La entrega digital es prácticamente inmediata. Una vez completados los datos y la firma electrónica mediante DocuSign, recibirás el PDF certificado en tu correo. El email de DocuSign puede tardar unas horas; revisa también tu carpeta de spam.',
      },
      {
        question: '¿Cuánto tarda el envío de un documento físico?',
        answer: 'Una vez que los datos son verificados y el documento entra a impresión, el envío a través de DHL Express toma entre 3 y 5 días hábiles a cualquier parte de la República Mexicana.',
      },
      {
        question: '¿Cómo rastro mi envío de DHL?',
        answer: 'Cuando tu documento físico es enviado, te notificamos por correo electrónico con el número de guía DHL. Puedes rastrear tu paquete directamente en el sitio de DHL con ese número.',
      },
    ],
  },
  {
    id: 'seguridad',
    label: 'Seguridad',
    icon: <SecurityIcon />,
    faqs: [
      {
        question: '¿Cómo protegen mis datos personales?',
        answer: 'Aplicamos medidas técnicas y administrativas para proteger tu información: cifrado en tránsito (HTTPS), almacenamiento seguro de sesiones con tokens validados y cumplimiento del Aviso de Privacidad. Nunca compartimos tus datos con terceros sin tu consentimiento.',
      },
      {
        question: '¿Es seguro pagar en la plataforma?',
        answer: 'Sí. Los pagos se procesan directamente a través de Stripe, una de las pasarelas de pago más seguras y certificadas a nivel mundial. Tus datos de tarjeta nunca se almacenan en nuestros servidores.',
      },
      {
        question: '¿Por qué debo cerrar sesión?',
        answer: 'Por seguridad, te recomendamos cerrar sesión cuando termines de usar la plataforma, especialmente si accedes desde un dispositivo compartido. Tu sesión expira automáticamente tras un período de inactividad.',
      },
    ],
  },
  {
    id: 'cuenta',
    label: 'Cuenta',
    icon: <AccountIcon />,
    faqs: [
      {
        question: '¿Cómo recupero mi contraseña?',
        answer: 'En la pantalla de inicio de sesión, selecciona la opción "Olvidé mi contraseña". Te enviaremos un correo con un enlace seguro para restablecerla. El enlace es válido por tiempo limitado por seguridad.',
      },
      {
        question: '¿Cómo veo mis documentos ya generados?',
        answer: 'Todos tus trámites (boletas y poderes) se guardan en la sección "Mi Perfil". Ahí puedes consultar el estado de cada documento, descargar los PDFs y gestionar tus facturas.',
      },
      {
        question: '¿Cómo contacto a soporte?',
        answer: 'Si no encuentras respuesta a tu duda, escríbenos a soporte@wisby.legal o usa el botón "Contáctanos" al final de este panel. Nuestro equipo te responderá a la brevedad.',
      },
    ],
  },
];

// Componente `WhatsAppIcon` que renderiza esta parte de la interfaz.
const WhatsAppIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.04 2a9.84 9.84 0 0 0-8.5 14.78L2 22l5.37-1.5A9.95 9.95 0 1 0 12.04 2Zm0 17.91a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3.19.89.85-3.11-.2-.32a8.08 8.08 0 1 1 6.97 3.85Zm4.44-6.06c-.24-.12-1.44-.71-1.66-.79-.22-.08-.38-.12-.55.12-.16.25-.63.79-.77.95-.14.17-.28.19-.52.07-.24-.12-1.03-.38-1.96-1.21a7.35 7.35 0 0 1-1.35-1.68c-.14-.24-.01-.37.11-.49.11-.11.24-.28.36-.42.12-.14.16-.24.24-.41.08-.16.04-.3-.02-.42-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.46a.88.88 0 0 0-.63.3c-.22.25-.83.81-.83 1.98 0 1.16.85 2.29.97 2.45.12.16 1.67 2.55 4.05 3.58.57.24 1.01.39 1.35.5.57.18 1.08.15 1.49.09.46-.07 1.44-.59 1.64-1.16.2-.57.2-1.05.14-1.16-.06-.1-.22-.16-.46-.28Z" />
  </svg>
);

// Componente `ChevronIcon` que renderiza esta parte de la interfaz.
const ChevronIcon = ({ expanded }) => (
  <svg
    width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
    style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

// Componente `FloatingHelp` que renderiza esta parte de la interfaz.
export default function FloatingHelp() {
  // Estado local `isOpen` y su actualizador, usados para reflejar cambios en la interfaz.
  const [isOpen, setIsOpen] = useState(false);
  // Estado local `activeCategory` y su actualizador, usados para reflejar cambios en la interfaz.
  const [activeCategory, setActiveCategory] = useState(FAQ_CATEGORIES[0].id);
  // Estado local `expandedIndex` y su actualizador, usados para reflejar cambios en la interfaz.
  const [expandedIndex, setExpandedIndex] = useState(null);
  // Estado local `isHovering` y su actualizador, usados para reflejar cambios en la interfaz.
  const [isHovering, setIsHovering] = useState(false);
  // Referencia mutable `panelRef` que conserva datos entre renderizados sin provocar uno nuevo.
  const panelRef = useRef(null);
  // Referencia mutable `savedScrollLock` que conserva datos entre renderizados sin provocar uno nuevo.
  const savedScrollLock = useRef(false);

  // Cerrar el panel si hacen clic afuera
  useEffect(() => {
    // Función `handleClickOutside` que gestiona la interacción o el evento correspondiente.
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  // ============================================
  // BLOQUEAR SCROLL DE LA PÁGINA AL HACER HOVER
  // Bloquea el scroll de la página principal (html + body)
  // cuando el mouse está sobre el centro de ayuda abierto.
  // El body interno del panel sigue siendo desplazable.
  // ============================================
  useEffect(() => {
    // Indicador booleano `shouldLock` que representa la condición señalada por su nombre.
    const shouldLock = isOpen && isHovering;

    if (shouldLock && !savedScrollLock.current) {
      document.body.classList.add('help-hover-scroll-lock');
      document.documentElement.classList.add('help-hover-scroll-lock');
      savedScrollLock.current = true;
    } else if (!shouldLock && savedScrollLock.current) {
      document.body.classList.remove('help-hover-scroll-lock');
      document.documentElement.classList.remove('help-hover-scroll-lock');
      savedScrollLock.current = false;
    }

    return () => {
      if (savedScrollLock.current) {
        document.body.classList.remove('help-hover-scroll-lock');
        document.documentElement.classList.remove('help-hover-scroll-lock');
        savedScrollLock.current = false;
      }
    };
  }, [isOpen, isHovering]);

  // Limpiar al cerrar
  useEffect(() => {
    if (!isOpen) {
      setExpandedIndex(null);
      setIsHovering(false);
    }
  }, [isOpen]);

  // Función `toggleFaq` que controla la navegación o visibilidad asociada.
  const toggleFaq = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // Función `handleCategoryChange` que gestiona la interacción o el evento correspondiente.
  const handleCategoryChange = (categoryId) => {
    setActiveCategory(categoryId);
    setExpandedIndex(null);
  };

  // Función `handleSupportEmail` que gestiona la interacción o el evento correspondiente.
  const handleSupportEmail = () => {
    // Valor intermedio `email` utilizado por la lógica de este bloque.
    const email = 'soporte@wisby.legal';
    // Valor intermedio `subject` utilizado por la lógica de este bloque.
    const subject = encodeURIComponent('Duda / Soporte técnico - Wisby Legal');
    // Valor intermedio `body` utilizado por la lógica de este bloque.
    const body = encodeURIComponent('Hola equipo de Wisby,\n\nTengo una duda acerca de:\n\n');
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  };

  // Valor intermedio `currentCategory` utilizado por la lógica de este bloque.
  const currentCategory = FAQ_CATEGORIES.find((c) => c.id === activeCategory) || FAQ_CATEGORIES[0];

  return (
    <div
      className="floating-help-wrapper"
      ref={panelRef}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Panel de Ayuda (Se muestra cuando isOpen es true) */}
      <div className={`help-panel ${isOpen ? 'active' : ''}`}>
        <div className="help-panel-header">
          <div className="help-panel-title-row">
            <div className="help-panel-title-text">
              <h3>Centro de Ayuda</h3>
              <p>Respuestas rápidas a dudas comunes.</p>
            </div>
            <RobotThinkingIcon />
          </div>
        </div>

        {/* Selector de categorías */}
        <div className="help-categories-bar">
          {FAQ_CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              className={`help-category-pill ${activeCategory === cat.id ? 'active' : ''}`}
              onClick={() => handleCategoryChange(cat.id)}
            >
              <span className="pill-icon">{cat.icon}</span>
              <span className="pill-label">{cat.label}</span>
            </button>
          ))}
        </div>

        <div className="help-panel-body">
          {currentCategory.faqs.map((faq, index) => {
            // Indicador booleano `isExpanded` que representa la condición señalada por su nombre.
            const isExpanded = expandedIndex === index;
            return (
              <div key={index} className={`faq-item ${isExpanded ? 'expanded' : ''}`}>
                <button className="faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.question}</span>
                  <ChevronIcon expanded={isExpanded} />
                </button>
                <div
                  className="faq-answer-wrapper"
                  style={{ maxHeight: isExpanded ? '400px' : '0' }}
                >
                  <div className="faq-answer">
                    {faq.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="help-panel-footer">
          <p>¿No encontraste lo que buscabas?</p>
          <button className="help-contact-btn" onClick={handleSupportEmail}>
            <span>Contáctanos</span><WhatsAppIcon />
          </button>
        </div>
      </div>

      {/* Botón Flotante */}
      <button
        className={`floating-help-btn ${isOpen ? 'is-open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        title="Ayuda y Soporte"
      >
        <div className="floating-help-icon-container">
          {isOpen ? (
            // Icono de Cerrar (X) cuando está abierto
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="help-icon close">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          ) : (
            // Icono de Pregunta (?) cuando está cerrado
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="help-icon question">
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          )}
        </div>
        <span className="floating-help-text">
          {isOpen ? 'Cerrar' : '¿Necesitas ayuda?'}
        </span>
      </button>

    </div>
  );
}
